import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  useStyles
} from "components/request-document/components/Commons";
import { useExtendsionFormPartG } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import { getErrorMessage } from "libs/utils/form";
import { get, isError } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";

export default function PartG() {
  const classes = useStyles();

  const { formik, onSaveDraft } = useExtendsionFormPartG();

  const masterData = useSelector(selectMasterData);

  const relationshipConfig = get(masterData, "relationshipConfig", []);
  const smartservice = get(masterData, "smartservice", []);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part G : Smart O
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        {`Please specify the name of  Smart Visa " T', "E", "I" or "S" holder or applicant whom you will accompany`}
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>First name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="accompanyFistName"
                        value={formik.values.accompanyFistName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("accompanyFistName", formik)}
                        helperText={getErrorMessage(
                          "accompanyFistName",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Middle name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="accompanyMiddleName"
                        value={formik.values.accompanyMiddleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("accompanyMiddleName", formik)}
                        helperText={getErrorMessage(
                          "accompanyMiddleName",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Last name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="accompanyLastname"
                        value={formik.values.accompanyLastname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("accompanyLastname", formik)}
                        helperText={getErrorMessage(
                          "accompanyLastname",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Select Type of his/her Smart Visa
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("accompanyTypeSmartVisa", formik)}
                        fullWidth
                      >
                        <InputLabel>
                          Select Type of his/her Smart Visa
                        </InputLabel>
                        <Select
                          label="Select Type of his/her Smart Visa"
                          name="accompanyTypeSmartVisa"
                          value={formik.values.accompanyTypeSmartVisa}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          fullWidth
                        >
                          {smartservice.map((service) => (
                            <MenuItem
                              value={service.smartserviceId}
                              key={service.smartserviceId}
                            >
                              {service.smartserviceName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("accompanyTypeSmartVisa", formik)}
                        >
                          {getErrorMessage("accompanyTypeSmartVisa", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Relationship with the main Smart Visa holder/applicant.
                      </InputLabel>
                      <FormGroup row>
                        {relationshipConfig.map((relationship) => (
                          <FormControlLabel
                            key={relationship.relationshipID}
                            control={
                              <StyleCheckbox
                                name={relationship.relationshipName}
                                value={relationship.relationshipID}
                                checked={
                                  formik.values.accompanyRelationship ===
                                  relationship.relationshipID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "accompanyRelationship",
                                    relationship.relationshipID
                                  );
                                }}
                              />
                            }
                            label={relationship.relationshipName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={3}>
                  {`Details of Smart "O" applicant's work or study in Thailand
                  (Please fill in this part in case the applicant works or studies in Thailand)`}
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Employer or education institution in Thailand
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="EmployerInThai"
                        value={formik.values.EmployerInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("EmployerInThai", formik)}
                        helperText={getErrorMessage("EmployerInThai", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>Job position or education level</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="JobPosition"
                        value={formik.values.JobPosition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobPosition", formik)}
                        helperText={getErrorMessage("JobPosition", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2} rowSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Work address or education institution address
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="WorkAddress"
                        value={formik.values.WorkAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("WorkAddress", formik)}
                        helperText={getErrorMessage("WorkAddress", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>Phone number</InputLabel>
                      <TextField
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="PhoneNumber"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.PhoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("PhoneNumber", formik)}
                        helperText={getErrorMessage("PhoneNumber", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Email"
                        value={formik.values.Email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Email", formik)}
                        helperText={getErrorMessage("Email", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Job description (Please fill in this part (No.6 - No.7)
                        if an applicant works in Thailand.)
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="JobDescription"
                        value={formik.values.JobDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobDescription", formik)}
                        helperText={getErrorMessage("JobDescription", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`A reference person's name`}</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="NameOfReference"
                        value={formik.values.NameOfReference}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("NameOfReference", formik)}
                        helperText={getErrorMessage("NameOfReference", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>{`A reference person's job title`}</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Position"
                        value={formik.values.Position}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Position", formik)}
                        helperText={getErrorMessage("Position", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>{`E-mail address`}</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="EmailReference"
                        value={formik.values.EmailReference}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("EmailReference", formik)}
                        helperText={getErrorMessage("EmailReference", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>{`Mobile phone number`}</InputLabel>
                      <TextField
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="MobilePhone"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.MobilePhone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("MobilePhone", formik)}
                        helperText={getErrorMessage("MobilePhone", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 35px",
          }}
        >
          <InputLabel>
            I hereby certify that the information and the evidence provided is
            true and complete in all respects. If there are any false statements
            which are considered perjury, I agrce to be subjected to any
            applicable legal prosecution.
          </InputLabel>
        </div>
        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
